import { useEffect, useState } from "react";
import Trade from "../../models/trade";
import { useNavigate } from "react-router-dom";
import tradeService from "../../services/tradeService";
import Page from "../../components/work/layout/Page";
import SearchBar from "../../components/work/layout/SearchBar";
//import Address from "../../models/address";

const Trades: React.FC = () => {
  const navigate = useNavigate();

  const [trades, setTrades] = useState<Trade[]>([]);
  const [allTrades, setAllTrades] = useState<Trade[]>([]);
  const [tradeSearch, setTradeSearch] = useState<string>("");

  useEffect(() => {
    const init = async () => {
      try {
        const { data: trades } = await tradeService.getTrades();
        setTrades(trades);
        setAllTrades(trades);
      } catch (error) {
        // TODO: show error with toastr
      }
    };

    init();
  }, []);

  const onSearchChange = (event: any) => {
    setTradeSearch(event.target.value);
    const searchToken = event.target.value.toLowerCase();
    const newTrades = allTrades.filter((a) =>
      a.tradeName.toLowerCase().includes(searchToken),
    );
    setTrades(newTrades);
  };

  const onCreateTradeClick = () => {
    navigate("/work/trades/new");
  };

  const onEditClick = (trade: Trade) => {
    navigate(`/work/trades/${trade.idTrade}`);
  };

  return (
    <Page
      pageTitle="Trades"
      breadcrumbs={[{ linkName: "Trades", linkUlr: "" }]}
    >
      <section className="section">
        <div className="card">
          {/* <div className="card-header">
            <div className="d-flex align-items-center">
              <form className="search-form">
                <i className="bi bi-search search-icon"></i>
                <input
                  type="search"
                  name="q"
                  placeholder="Search accounts..."
                  autoComplete="off"
                  value={tradeSearch}
                  onChange={onSearchChange}
                />
              </form>
            </div>

            <div className="d-flex flex-column align-items-end">
              <button
                className="btn btn-primary"
                onClick={() => onCreateTradeClick()}
              >
                <i className="bi bi-plus-lg me-1"></i> Create Trade
              </button>
              <div
                style={{
                  visibility: trades.length > 0 ? "visible" : "hidden",
                }}
              >{`${trades.length} trades`}</div>
            </div>
          </div> */}

          <SearchBar
            placeHolderText="Search trades..."
            searchValue={tradeSearch}
            onSearchChange={onSearchChange}
            hasCreate={true}
            createTitle="Create Trade"
            onCreate={() => onCreateTradeClick()}
            count={trades.length}
            countType="trades"
          />

          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover table-responsive">
                <thead>
                  <tr>
                    <th scope="col">Trade Name</th>
                    {/* <th scope="col">Shipping Address</th>
                      <th scope="col">Email</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Trades</th> */}
                    <th style={{ width: "50px" }} />
                  </tr>
                </thead>
                <tbody>
                  {trades.map((trade: Trade) => (
                    <tr key={trade.idTrade.toString()}>
                      <td>{trade.tradeName}</td>
                      {/* <td>{Address.toString(maintenanceCompany.shippingAddress)}</td>
                        <td>{MaintenanceCompany.emailsToString(maintenanceCompany)}</td>
                        <td>{MaintenanceCompany.phonesToString(maintenanceCompany)}</td>
                        <td>{MaintenanceCompany.tradesToString(maintenanceCompany)}</td> */}
                      <td>
                        <i
                          className="ri-pencil-fill"
                          style={{ fontSize: "20px", cursor: "pointer" }}
                          onClick={() => onEditClick(trade)}
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
};

export default Trades;
